import React, { useState } from "react";
import FlechaIcon from "../../../assets/images/generico/FlechaIcon";
import "./ConsultasSolicitadas.css";

const ConsultasSolicitadas = ({ items }) => {
  const [selected, setSelected] = useState(items[0].title);
  const handleClickMenu = (val) => {
    setSelected(val.title);
    // history.push(val.link);
  };

  return (
    <div className="ptur-consultas-card">
      <span className="ptur-label-consultas rb14b c-black10">
        Ver mis consultas más solicitadas
      </span>
      <div>
        <ul className="ptur-list-consultas">
          {items.map((val, index) => {
            const itemSelected = selected === val.title;
            return (
              <React.Fragment key={index}>
                <li
                  className="ptur-option-consultas rb16t"
                  id={itemSelected ? "active" : ""}
                  onClick={() => handleClickMenu(val)}
                >
                  {val.title}
                  <FlechaIcon color={"#A6A6A6"} />
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ConsultasSolicitadas;
